import { FC, useCallback } from 'react';
import { IActivities, IActivity } from '../../../types/activities.types';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { COLORS, FONTS } from '../../../constants';
import { NavigationService } from '../../../services/navigation';
import { useIsDesktop } from '../../../hooks/useIsDeskTop';
import { Button } from '../../../components/Button';
import dayjs from 'dayjs';
import { isSameDate } from '../../../services/utils/dateConvert';
import { DATE_TYPE } from '../../../constants/activity';
import { convertToAmPm } from '../../../services/utils';

interface ActivityItemProps {
  item: IActivity;
  onPress: () => void;
}

const ActivityItem: FC<ActivityItemProps> = ({ item, onPress }) => {
  const isDesktop = useIsDesktop();

  return (
    <View
      style={[
        {
          paddingBottom: 25,
        },
        !isDesktop() && {
          borderBottomWidth: 1,
          borderBottomColor: COLORS.GREY,
        },
      ]}
    >
      {/* <Text
        style={{
          fontFamily: FONTS.Arial,
          fontWeight: '700',
          fontSize: 20,
          letterSpacing: 1.7,
          color: COLORS.BLACK,
          textTransform: 'uppercase',
          borderBottomWidth: 1,
          paddingBottom: 15,
          marginBottom: 15,
          borderBottomColor: COLORS.GREY,
        }}
        onPress={onPress}
      >
        {item.camp.name}
      </Text> */}
      <View style={{ flexDirection: isDesktop() ? 'row' : 'column', gap: 15 }}>
        <TouchableOpacity onPress={onPress}>
          <Image
            source={
              item.image
                ? {
                    uri: item.image,
                  }
                : require('../../../assets/activities-image.png')
            }
            style={{
              width: isDesktop() ? 312 : '100%',
              height: 175,
              borderRadius: 18,
            }}
          />
        </TouchableOpacity>
        <View
          style={{
            flex: 1,
          }}
        >
          <Text
            style={{
              fontFamily: FONTS.AvenirMedium,
              fontWeight: '800',
              fontSize: 19,
              letterSpacing: 1,
              marginBottom: 10,
              color: COLORS.BLACK,
            }}
            onPress={onPress}
          >
            {item.name}
          </Text>
          <View
            style={{
              width: 58,
              height: 2,
              backgroundColor: COLORS.RED_PRIMARY,
              marginBottom: 10,
            }}
          />
          {item.date_type.value === DATE_TYPE.NORMAL ? (
            item.start_date === item.end_date ? (
              <Text style={styles.text}>
                {`${dayjs(item.start_date).format('MMMM DD, YYYY')}`}
              </Text>
            ) : (
              <>
                <Text style={styles.text}>
                  {`Start: ${dayjs(item.start_date).format('MMMM DD, YYYY')}`}
                </Text>
                <Text style={styles.text}>
                  {`End: ${dayjs(item.end_date).format('MMMM DD, YYYY')}`}
                </Text>
              </>
            )
          ) : (
            <Text style={styles.text}>{item.date_type.name}</Text>
          )}
          <Text style={styles.text}>
            {`${convertToAmPm(item.start_time)} - ${convertToAmPm(
              item.end_time
            )}`}
          </Text>
          <Text style={styles.text}>{item.type}</Text>
          <Text style={styles.text}>{item.venue}</Text>
          <View
            style={{
              flexDirection: 'row',
              gap: isDesktop() ? 15 : 8,
              alignItems: 'center',
            }}
          >
            <Button
              text="Read more"
              className=""
              style={{
                borderRadius: 12,
                paddingHorizontal: isDesktop() ? 40 : 30,
                paddingVertical: isDesktop() ? 7 : 8,
                backgroundColor: COLORS.RED_PRIMARY,
              }}
              textStyle={{
                textTransform: 'uppercase',
                fontFamily: FONTS.AvenirMedium,
                fontWeight: isDesktop() ? '800' : '500',
                fontSize: isDesktop() ? 16 : 16,
                textAlign: 'center',
                color: COLORS.WHITE,
                letterSpacing: 2,
              }}
              arrowRight={false}
              onPress={onPress}
            />
          </View>
        </View>
      </View>
    </View>
  );
};

export default ActivityItem;

const styles = StyleSheet.create({
  text: {
    fontFamily: FONTS.AvenirMedium,
    fontWeight: '500',
    fontSize: 15,
    color: COLORS.GREY,
    letterSpacing: 1,
    marginBottom: 7,
  },
});
